export default "__VITE_ASSET__DAHD2w_Z__"